import { Component, ElementRef, OnInit, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { SeguridadService } from '../_services/seguridad.service'
import { Subscription } from 'rxjs/Subscription';

import { PreguntasService } from '../_services/preguntas.service';
import { NormasService } from '../_services/normas.service';
import { EvidenciasService } from '../_services/evidencias.service';
import { EmpresasService } from '../_services/empresas.service';

import { DropdownPregunta } from '../_models/preguntabase-dropdown.model';

import { UsuariosService } from '../_services/usuarios.service';

import {GlobalEventsManager} from "../_services/globaleventsmanager.service";

import {ConfirmDialogModule,ConfirmationService} from 'primeng/primeng';

declare var jQuery:any;

@Component({
  selector: 'actividades',
  templateUrl: 'actividades.template.html',
  providers:  [PreguntasService]
})
export class ActividadesComponent  implements OnInit, OnDestroy {

  questions: any[];
  formulario: string;
  subscription: Subscription;
  listaactividades: any[];
  actividadseleccionada: number = 0;
  htmlForm: string;
  detalleactividad: boolean = true;
  formactividad: boolean = false;

  iconocerrar: string = 'fa fa-times';
  iconoexpandir: string = 'fa fa-expand';

  puedoeditaractividad: boolean = true;

  listapermisos: any = [];
  permisocrearactividad: boolean = false;

  filterQuery: string = "";
  filterQueryEvidencias: string = "";

  listaevidencias: any = [];
  formevidencia: boolean = false;
  detalleevidencia: boolean = true;
  puedoeditarevidencia: boolean = true;
  evidenciaseleccionada: number = 0;

  permisocrearevidencia: boolean = false;
  copiaevidencia: boolean = false;
  copianorma: boolean = false;

  mostrarmodalevidenciasafectapersonal:boolean = false;


  constructor(private router:Router,
              private seguridad: SeguridadService,
              private service: PreguntasService,
              private normasService: NormasService,
              private globalEventsManager: GlobalEventsManager,
              private elementRef:ElementRef,
              private usuariosService : UsuariosService,
              private empresasService: EmpresasService,
              private confirmationService: ConfirmationService,
              private evidenciasService: EvidenciasService,
              private activatedRoute: ActivatedRoute){
    //this.questions = service.getQuestions();


  }

  ngOnInit(){

    this.globalEventsManager.menuExtendido(true);

    this.seguridad.getLogado();

    this.subscription = this.seguridad.dejoPasarUsuarioEmitter.subscribe((mode)=>{
            if (mode !== null) {
              //console.log("ET: "+mode);
              if (!mode){
                this.router.navigate(['login']);
              }
            }
        });

    let id_norma = this.activatedRoute.snapshot.params["id"];
    if (id_norma){
      //console.log("entro normas");
      this.cargarActividad(id_norma);

    }

    this.getListaActividades();
    this.actualizarBreadcrumb();
    this.getListaPermisos();


  }

  ngOnDestroy(){
    this.subscription.unsubscribe();
  }

  getListaPermisos(){
    this.usuariosService.getUsuarioListaPermisos().subscribe(
      data => {
        if (data){
          this.listapermisos = data.json().lista;

          //console.log(this.listapermisos);

          for (let i = 0; i < this.listapermisos.length; i++){

            if (this.listapermisos[i].codigo == "MOD0010"){
              this.permisocrearactividad = true;
            }

            if (this.listapermisos[i].codigo == "MOD0013"){
              this.permisocrearevidencia = true;
            }

          }

        }
      }
    );
  }

  getListaActividades(){
    console.log("voy a recuperar");
    this.empresasService.getListaActividades().subscribe(
      data => {
        console.log(data.json().actividades);
        this.listaactividades = data.json().actividades;
      }
    );
  }

  actualizarBreadcrumb(){
    let breadcrumb: any = [];

    let item = {
      'path':'#',
      'name': 'Actividades'
    };
    breadcrumb.push(item);

    this.globalEventsManager.setNombrePagina(breadcrumb);
  }

  cargarActividad(id){

    this.actividadseleccionada = id;

    this.formevidencia = false;

    this.formulario = "";
    this.formulario = "mostrar";

  }

  verActividad(id){

    this.formactividad = true;
    this.formevidencia = false;
    this.detalleactividad = false;

    this.actividadseleccionada = +id;

    this.puedoeditaractividad = false;

    this.cargarActividad(id);

  }

  editarActividad(id_actividad:number){
    this.formactividad = true;
    this.detalleactividad = false;

    this.actividadseleccionada = id_actividad;
    this.puedoeditaractividad = true;
    this.cargarActividad(id_actividad);
  }

  nuevaActividad(){
    this.editarActividad(0);
  }

  stripText(val: string){
    var cadena: string = "";

    if (val != null){
      if (val.length>25){
        cadena = val.substr(0, 25)+"...";
      }else{
        cadena = val;
      }
    }

    return cadena;
  }

  expandir(nivel:number){
    if (nivel == 1){
      (this.detalleactividad) ? this.detalleactividad = false : this.detalleactividad = true;
    }
    if (nivel == 2){
      (this.detalleevidencia) ? this.detalleevidencia = false : this.detalleevidencia = true;
    }
  }

  borrarActividad(id_actividad: number){
    this.empresasService.deleteActividad(id_actividad).subscribe(
      data => {
        if (data){
          this.cerrar(1);
          this.getListaActividades();
        }
      }
    );
  }

  confirmActividad(id_actividad: number) {
    this.confirmationService.confirm({
      message: '¿Seguro que deseas eliminar la actividad?',
      accept: () => {
        this.borrarActividad(id_actividad);
      }
    });
  }

  onChangeActividad(event){
    if(event){
      this.cerrar(1);
      this.getListaActividades();
    }
  }

  onCloseActividad(event: number){
    this.cerrar(1);
  }

  cerrar(nivel:number){

   //le pasamos el nivel al que tiene que ir

  if (nivel <= 1){
    this.actividadseleccionada = 0;
    this.detalleactividad = true;
    this.formactividad = false;
  }

  if (nivel <= 2){
    this.evidenciaseleccionada = 0;
    this.detalleevidencia = true;
    this.formevidencia = false;
  }

    this.actualizarBreadcrumb();
  }

  scrollLienzo(){
    jQuery(".wrap-app").animate({scrollLeft: 5000}, 1000);
  }

  /****************************** evidencias *****************************/

  getEvidencias(id_actividad: number ){
    //console.log("entro");
    this.detalleactividad = false;
    this.detalleevidencia = true;
    this.formevidencia = false;
    this.formactividad = false;
    this.actividadseleccionada = id_actividad;
    this.evidenciasService.getListaEvidenciasAfectaPersonalActividad(id_actividad).subscribe(
      data => {
        //console.log(data.json().lista);
        this.listaevidencias = data.json().evidencias;
      }
    );
  }

  visualizarEvidencia(id_evidencia: number){
    this.puedoeditarevidencia = false;
    this.getEditarEvidencia(id_evidencia);

  }

  getEditarEvidencia(id_evidencia: number){


    this.detalleevidencia = false;
    this.evidenciaseleccionada = id_evidencia;
    this.formevidencia = true;

    this.scrollLienzo();
  }

  onCloseEvidencia(event: number){
    this.cerrar(2);
  }

  onChangeEvidencia(event){
    //if(event){
    if(event.anadir == false){
      this.cerrar(2);
      this.getEvidencias(this.actividadseleccionada);
    }else{
      this.getEvidencias(this.actividadseleccionada);
    }
  }

  nuevaEvidencia(){

    this.editarEvidencia(0);
  }

  editarEvidencia(id_evidencia:number){
    this.puedoeditarevidencia = true;
    this.copiaevidencia = false;
    this.getEditarEvidencia(id_evidencia);
  }

  copiarEvidencia(id_evidencia:number){
    this.puedoeditarevidencia = true;
    this.copiaevidencia = true;
    this.getEditarEvidencia(id_evidencia);
  }

  borrarEvidencia(id_evidencia: number){

    this.evidenciasService.deleteEvidenciaAfectaPersonalActividad(id_evidencia, this.actividadseleccionada).subscribe(
      data => {
        if (data){
          this.getEvidencias(this.actividadseleccionada);
        }
      }
    );
  }

  confirmEvidencia(id_evidencia: number) {
      this.confirmationService.confirm({
          message: '¿Seguro que deseas eliminar la evidencia?',
          accept: () => {
              this.borrarEvidencia(id_evidencia);
          }
      });
  }

  anadirEvidencia(){
    this.mostrarmodalevidenciasafectapersonal = true;
    this.scrollLienzo();
  }

  onChangeModalEvidenciasAfectaPersonal(event){
    this.mostrarmodalevidenciasafectapersonal = false;
    this.getEvidencias(this.actividadseleccionada);
    this.scrollLienzo();
  }


}



// WEBPACK FOOTER //
// ./src/app/actividades/actividades.component.ts